module.exports = __webpack_public_path__ + "resources/img/logo_partner_commerce_SKmagic.a950ca3dd7678d7f04d9040057b17d41.png";